import {API, graphqlOperation, Amplify} from 'aws-amplify'
import moment from 'moment'


const getQueryName = gql => gql.match(/query[^{]+{\s*(?<queryName>\w+)[^{]+{/).groups.queryName
const getMutationName = gql => gql.match(/mutation[^{]+{\s*(?<mutationName>\w+)[^{]+{/).groups.mutationName
const processGqlOperation = async (graphql, variables, responseConverter) => {
    // Debug: Mostrar información de la petición GraphQL
    console.group('🔍 processGqlOperation Debug');
    console.log('📤 GraphQL Query:', graphql);
    console.log('📤 Variables:', variables);
    console.log('📤 Response Converter:', responseConverter(graphql));
    
    // Mostrar configuración del API
    console.log('📡 API Configuration:');
    // Acceder correctamente a la configuración de Amplify
    const amplifyConfig = API._config || {};
    const appSyncConfig = amplifyConfig.aws_appsync || {};
    
    console.log('- Endpoint:', amplifyConfig.aws_appsync_graphqlEndpoint || appSyncConfig.graphqlEndpoint || 'No configurado');
    console.log('- Region:', amplifyConfig.aws_appsync_region || appSyncConfig.region || 'No configurado');  
    console.log('- Auth Type:', amplifyConfig.aws_appsync_authenticationType || appSyncConfig.authenticationType || 'No configurado');
    
    // Debug adicional: mostrar toda la configuración disponible
    console.log('📋 Full API Config Keys:', Object.keys(amplifyConfig));
    console.log('📋 AppSync Config:', appSyncConfig);
    
    // Debug de la configuración completa de Amplify
    const amplifyFullConfig = Amplify._config || {};
    console.log('🔧 Amplify Full Config Keys:', Object.keys(amplifyFullConfig));
    console.log('🔧 Amplify GraphQL Endpoint:', amplifyFullConfig.aws_appsync_graphqlEndpoint);
    console.log('🔧 Amplify AppSync Region:', amplifyFullConfig.aws_appsync_region);
    console.log('🔧 Amplify Auth Type:', amplifyFullConfig.aws_appsync_authenticationType);
    
    try {
        const {data: {[responseConverter(graphql)]: response}} = await API.graphql(graphqlOperation(graphql, variables))
        console.log('📥 Response:', response);
        console.log('📥 Response type:', typeof response);
        console.log('📥 Is Array:', Array.isArray(response));
        console.log('📥 Is Null:', response === null);
        console.groupEnd();
        return response
    } catch (error) {
        console.error('❌ GraphQL Error:', error);
        console.groupEnd();
        throw error;
    }
}

export const convertTimestamps = entity => entity ? Object.fromEntries(
    Object.entries(entity)
        .map(([name, value]) => {
            if (['createdAt', 'updatedAt'].includes(name))
                return [name, moment.unix(value)]
            else
                return [name, value]
        })
) : entity

export const escapeRawData = rawData => JSON.stringify(JSON.stringify(rawData)).slice(1, -1).replace(/'/g, "\\'")
export const unescapeRawData = rawData => JSON.parse(rawData)

export async function executeGraphQLMutationCreate(graphql, input) {
    const response = await processGqlOperation(graphql, input, getMutationName)
    return convertTimestamps(response)
}

export async function executeGraphQLMutationUpdate(graphql, input) {
    const response = await processGqlOperation(graphql, input, getMutationName)
    return convertTimestamps(response)
}

export async function executeGraphQLMutationDelete(graphql, input) {
    const response = await processGqlOperation(graphql, input, getMutationName)
    return convertTimestamps(response)
}

export async function executeGraphQLQueryGet(graphql, input) {
    const response = await processGqlOperation(graphql, input, getQueryName)
    return convertTimestamps(response)
}

export async function executeGraphQLQueryList(graphql, input={}, listName, limit, nextTokens=[]) {
    const nextTokensCollection = Object.fromEntries(nextTokens.map(tokenName => [tokenName, null]))
    const data = []

    // Debug mejorado para executeGraphQLQueryList
    console.group('🔍 executeGraphQLQueryList Debug');
    console.log('📤 GraphQL Query:', graphql);
    console.log('📤 Input Variables:', input);
    console.log('📤 List Name:', listName);
    console.log('📤 Limit:', limit);
    console.log('📤 Next Tokens:', nextTokens);
    console.log('📤 Next Tokens Collection:', nextTokensCollection);
    
    // Identificar qué query específica se está ejecutando
    const queryName = graphql.match(/query[^{]+{\s*(?<queryName>\w+)[^{]+{/)?.groups?.queryName || 'Unknown';
    console.log('📋 Query Name:', queryName);
    
    // Mostrar información del token de autenticación actual
    const tokenKeys = Object.keys(localStorage).filter(key => key.includes('idToken'));
    if (tokenKeys.length > 0) {
        const token = localStorage.getItem(tokenKeys[0]);
        console.log('🔑 Auth Token (primeros 50 chars):', token ? token.substring(0, 50) + '...' : 'null');
    } else {
        console.log('❌ No se encontró token de autenticación');
    }
    console.groupEnd();

    const executeQuery = () => new Promise((resolve, reject) => {
        processGqlOperation(graphql, {...input, ...(limit ? {limit} : {}), ...nextTokensCollection}, getQueryName)
            .then(response => {
                // Manejar el caso cuando response o response[listName] es null
                const responseData = listName ? response[listName] : response
                if (responseData && Array.isArray(responseData)) {
                    data.push(...responseData.map(i => convertTimestamps(i)))
                } else if (responseData === null) {
                    console.warn('GraphQL query returned null, skipping data processing')
                } else {
                    console.warn('GraphQL query returned unexpected data type:', typeof responseData, responseData)
                }
                
                if (
                    nextTokens.length &&
                    nextTokens.every(tokenName => {
                       nextTokensCollection[tokenName] = response[tokenName]
                       return !!response[tokenName]
                   })
                )
                    resolve(executeQuery())
                else
                    resolve()
            })
            .catch(reject)
    })

    await executeQuery()
    
    // Debug del resultado final
    console.group('📥 executeGraphQLQueryList Result');
    console.log('📊 Final Data Length:', data.length);
    console.log('📊 Final Data:', data);
    if (data.length === 0) {
        console.warn('⚠️ executeGraphQLQueryList retornó array vacío');
    }
    console.groupEnd();
    
    return data
}